const localHosts = ["localhost", "127.0.0.1"];
const testPorts = ["3002"];
const stageUrls = ["https://appdev.newstatements.com"];
const prodUrls = ["https://newstatements.com", "https://www.newstatements.com"];

/**
 * Resolves the runtime environment from the page URL.
 * Any localhost port is "dev" (Vite runs on 44415 with `npm start`, 3001 with `npm run dev`),
 * except the test port 3002.
 */
export function getEnv() {
  const { hostname, port, href } = window.location;
  if (localHosts.includes(hostname)) {
    return testPorts.includes(port) ? "test" : "dev";
  }
  if (stageUrls.some((url) => href.startsWith(url))) {
    return "stage";
  }
  if (prodUrls.some((url) => href.startsWith(url))) {
    return "prod";
  }
  return "prod";
}
